import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import Skeleton from 'react-loading-skeleton';
import { cx } from '@emotion/css';

import { Button } from '@phoenix/design-system/frontend/ui/button/button';
import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';
import { link } from '@phoenix/core/frontend/shared/util/navigation/link.utils';
import { PhoenixIcon } from '@phoenix/design-system/frontend/ui/phoenix-icon/phoenix-icon';
import { useDealerMapContext } from '@phoenix/core/frontend/shared/ui/dealers/context/dealer-map-context';
import { DealerDetails } from '@phoenix/core/frontend/shared/ui/dealers/components/dealer-details';
import { useDealerLocations } from '@phoenix/core/frontend/shared/ui/dealers/hooks/use-dealer-locations.hook';

const pinIcon = getDesignSystemIcon('icon-pin-16.svg');
const circleInfoIcon = getDesignSystemIcon('icon-circle-info.svg');

export const MainDealer: FC = () => {
  const { t } = useTranslation();
  const { selectedDealer } = useDealerMapContext();
  const {
    favoriteDealersQuery: { isFetching, isError },
  } = useDealerLocations();

  return (
    <>
      <div className={cx('mt-6 desktop:mt-8', !isFetching && 'rounded-lg border border-secondary')}>
        <DealerDetails
          layout="HORIZONTAL"
          displayConfig={{
            phoneNumberEnabled: true,
            openingHoursEnabled: true,
            openingHoursHeadline: true,
            preferencesEnabled: true,
            visitWebsiteButton: true,
            writeEmailButton: true,
          }}
        />
        {isFetching ? (
          <Skeleton height={120} />
        ) : (
          !selectedDealer && (
            <div className="flex items-start space-x-2 p-6">
              <div className="mt-1">
                <PhoenixIcon icon={circleInfoIcon} />
              </div>
              {isError ? (
                <span className="stihl-text-body-default-reg">{t('dashboard_mainDealer_section_loading_error')}</span>
              ) : (
                <span className="stihl-text-h4-desktop">{t('dashboard_mainDealer_section_empty')}</span>
              )}
            </div>
          )
        )}
      </div>
      <Button
        as="a"
        href={link('/profile/dealers')}
        className="mt-4 tablet:inline-block"
        btnType="white_default"
        icon={pinIcon}
        data-testid="manageDealersBtn"
        iconPosition="left"
      >
        {t('dashboard_mainDealer_button_manageDealers')}
      </Button>
    </>
  );
};
